import React, { FC } from 'react';
import { Image } from '@/components/ui/Image';
import { TypeImage, TypeImagePairWithTextFields } from '@/core/generated-types';
import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';
import { RichText } from '@/components';
import { Document } from '@contentful/rich-text-types';
import styles from './ImagePairWithText.module.scss';

export const ImagePairWithText: FC<TypeImagePairWithTextFields> = ({
  entryName,
  heading = '',
  imageLeft,
  imageRight,
  richText,
  anchorId,
}) => {
  return (
    <section
      data-testid={`image-pair-with-text-${entryName}`}
      className={`mx-auto py-10 text-center lg:py-20 ${styles.imagePairWithText}`}
      id={anchorId}
    >
      <Heading
        tag={HeadingTag.H2}
        size={HeadingSize.H2}
        classes="container mx-auto mb-5 lg:mb-10"
        align="center"
        text={heading}
      />
      <div className="mx-auto mb-5 grid max-w-[900px] grid-cols-2 gap-4 lg:mb-10">
        <Image
          imageData={imageLeft as TypeImage}
          className=""
          alt={imageLeft?.fields?.altText}
          height={900}
          width={900}
        />
        <Image
          imageData={imageRight as TypeImage}
          className=""
          alt={imageRight?.fields?.altText}
          height={900}
          width={900}
        />
      </div>
      {richText && (
        <div className="mx-auto max-w-[700px] px-4">
          <RichText content={richText as Document} />
        </div>
      )}
    </section>
  );
};
